import { Grip, LayoutDashboard, List, PieChart } from '@tamagui/lucide-icons';
import { TabBarButton } from '@unistocks/components/tab-bar-button/tab-bar-button';
import { t } from '@unistocks/localization';
import { quicker, quickest } from '@unistocks/shared/animations';
import { usePrefetchUserQueries } from '@unistocks/shared/hooks/use-prefetch-queries';
import { useTabBarStyle } from '@unistocks/shared/hooks/use-tab-bar-style';
import { Tabs } from 'expo-router';
import { SceneStyleInterpolators } from 'expo-router/build/react-navigation/bottom-tabs';

export default function TabLayout() {
  usePrefetchUserQueries();
  const tabBarStyle = useTabBarStyle();

  return (
    <Tabs
      screenOptions={{
        lazy: true,
        freezeOnBlur: true,
        sceneStyle: { backgroundColor: 'transparent' },
        tabBarAllowFontScaling: false,
        tabBarHideOnKeyboard: true,
        tabBarShowLabel: false,
        tabBarVisibilityAnimationConfig: {
          show: { animation: 'spring', config: quickest },
          hide: { animation: 'spring', config: quickest }
        },
        tabBarStyle,
        headerShown: false,
        animation: 'shift',
        sceneStyleInterpolator: SceneStyleInterpolators.forShift,
        transitionSpec: {
          animation: 'spring',
          config: quicker
        }
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          headerShown: false,
          title: t('::Menu:Dashboard'),
          tabBarButton: props => (
            <TabBarButton Icon={LayoutDashboard} label={t('::Menu:Dashboard')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="portfolios"
        options={{
          tabBarButton: props => (
            <TabBarButton Icon={PieChart} label={t('::Menu:Portfolios')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="watchlists"
        options={{
          tabBarButton: props => (
            <TabBarButton Icon={List} label={t('::Menu:Watchlists')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="(menu)"
        options={{
          popToTopOnBlur: true,
          tabBarButton: props => <TabBarButton Icon={Grip} label={t('::Menu:More')} {...props} />
        }}
      />

      <Tabs.Screen
        name="notifications"
        options={{
          href: null,
          title: t('::Menu:Notifications')
        }}
      />

      <Tabs.Screen
        name="share"
        options={{
          href: null,
          title: t('::Portfolio:Share:AcceptShare')
        }}
      />

      <Tabs.Screen
        name="asset"
        options={{
          href: null
        }}
      />
    </Tabs>
  );
}
